import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'

export default (props) => {
  return <a {...props} onClick={(e) => {
    tracker.trackEvent('userevent', props.track)
    Analytics.send(props.gaEvents.eventCategory, props.gaEvents.eventAction, props.gaEvents.eventLabel)
    if (typeof props.onClick === 'function') {
      props.onClick(e)
    }
  }}>{props.children}</a>
}
